import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "product-card-solutions",
  "use": "product-card-solutions-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"product-card-solutions\"><path d=\"M16.32 8.69L11.62 4 6.95 8.69a6.63 6.63 0 109.38 0zm-4.7 9.66a4.91 4.91 0 01-3.5-1.46 4.93 4.93 0 010-7.02l3.5-3.53v12.01z\" fill=\"#003595\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol